
export function areSame(a: any, b: any) {
    return (a && b)
     ? JSON.stringify(a) === JSON.stringify(b)
     : a === b
}